import type { FaireProductEntity } from "../../entity_types/product";

export const p_xby5uxea7w: FaireProductEntity = {
  token: "p_xby5uxea7w",
  type: "product",
  name: "Aster",
  brandToken: "b_d3mdkn2j3h",
  brandName: "Verve Coffee Roasters",
  imageUrl: "https://cdn.faire.com/fastly/aa34c6df84ceab30e6016da8a1013c5f494c5473b770f2ebcb3cf7ada9828664.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/4310e5833de6ab508c51059503c271f702a71921034d2d0179bd2e18708d5c62.png",
    "https://cdn.faire.com/fastly/9aa43df7b52c23e2ad26b422424318972259e1894b5547ede733f4a98a139ca0.png"
  ],
  priceDollars: 79,
  description: "Aster highlights the best of what Ethiopian coffee has to offer. A key lime sweetness and brown sugar complexity come together to inspire adventure in your morning. As our only blend sourced from a single origin and roasted in two different ways, Aster is our star on the map that marks the birthplace of coffee – Ethiopia.\n\n𝐃𝐞𝐭𝐚𝐢𝐥𝐬\n• Medium Roast\n• Tasting Notes: Nectarine, Key Lime, Brown Sugar\n• Country of Origin: Ethiopia\n• Producer: Various Producers\n• Cultivar: Varies Seasonally\n• Processing Method: Washed\n• Elevation: 2000-2200 Meters",
  tags: [],
  msrpDollars: 158,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-09-08T20:58:13.528Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
